import { render, staticRenderFns } from "./Kubernetes.vue?vue&type=template&id=8d0882a0&scoped=true"
import script from "./Kubernetes.vue?vue&type=script&lang=js"
export * from "./Kubernetes.vue?vue&type=script&lang=js"
import style0 from "./Kubernetes.vue?vue&type=style&index=0&id=8d0882a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0882a0",
  null
  
)

export default component.exports